<script lang="ts" setup>
export interface SubmenuCategoryTitleProps {
    title: string
    slug: string
    icon?: string
}
const props = defineProps<SubmenuCategoryTitleProps>()
</script>
<template>
  <VNuxtLink
    :to="
      useNamedRoutes({
        name: 'insurance-category-detail',
        params: { id: props.slug },
      })
    "
    class="px-4 flex-shrink-0 d-flex align-items-center fw-bold text-black"
  >
    <img
      v-if="props.icon"
      :src="props.icon"
      alt=""
      width="24"
      height="24"
      loading="lazy"
      decoding="async"
      class="submenu-link-icon me-3 transition d-flex align-items-center justify-content-center"
    >
    {{ props.title }}
  </VNuxtLink>
</template>

<style lang="scss" scoped>
@import '../../link/SubmenuLink.scss';
</style>
